import React, { Component } from 'react'
import { Link } from "react-router-dom";
import Phones from "../lib/phones-service";

class HomePhones extends Component {
    state = {
        phones: [],
        isLoading: true,
        getError: false
    };

    componentDidMount() {
        Phones.getProducts()
            .then(data => {
                this.setState({
                    phones: data,
                    isLoading: false
                });
            })
            .catch((error) => {
                this.setState({getError: true});
                console.error("Error 🔥", error);
            });
    }

    render() {
        return (
            <div className="container mt-6 pt-5">
                <h1 className="title is-1">Phone catalogue API 📱</h1>
                <br></br>
                {this.state.phones.length > 0 & this.state.getError === false ?
                    <>
                        <div className="notification is-primary">
                            Loaded {this.state.phones.length} <strong>phones</strong> successfully 👌.
                        </div>
                        <div className="columns is-desktop is-multiline is-3">
                            {this.state.phones.map(phone => {
                                return (
                                    <div className="column is-one-third" key={phone._id}>
                                        <div className="card">
                                            <div className="card-image">
                                                <div className="image is-4by3 is-vcentered is-horizontal-center">
                                                    <img className="img-phone is-horizontal-center" src={phone.imageFileName} alt={phone.name} />
                                                </div>
                                            </div>
                                            <div className="card-content">
                                                <div className="media">
                                                    <div className="media-content">
                                                        <h2 className="title is-4">{phone.name}</h2>
                                                        <p className="subtitle is-6">{phone.manufacturer}</p>
                                                    </div>
                                                </div>
                                            </div>
                                        <footer className="card-footer">
                                            <Link to={`/${phone._id}`} className="card-footer-item fas fa-edit">View</Link>
                                        </footer>
                                        </div>
                                    </div>
                                );
                            })}
                        </div>

                    </>
                    : <>
                        <div className="notification is-warning">
                            <h2>Loading phones...</h2>
                        </div>
                    </>}
            </div>
        )
    }
}

export default HomePhones;
